/**
 * Repõe scroll da app (window + elemento scrollável opcional).
 *
 * @param {HTMLElement | null | undefined} container
 */
export function resetAppScroll(container) {
  if (container) {
    container.scrollTop = 0;
    container.scrollLeft = 0;
  }

  window.scrollTo(0, 0);
  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0;
}
